import { useRef } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "../../../components/Icons";
import { DefaultFlowTemplateData } from "../../../types/FlowTemplates";

export default function FlowTemplateCarousel({
  allFlowTemplates,
  activeTemplate,
  handleClick,
}: {
  allFlowTemplates: DefaultFlowTemplateData[];
  activeTemplate: DefaultFlowTemplateData | null;
  handleClick: (id: number) => void;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollByAmount = (amount: number) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="relative w-[350px] xl:w-[500px]"
      id="flow-template-carousel"
    >
      {/* Left Button */}
      <button
        onClick={() => scrollByAmount(-200)}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-1 hover:bg-gray-100"
      >
        <ChevronLeftIcon className="w-5 h-5 text-gray-700" />
      </button>

      {/* Scrollable Container */}
      <div
        ref={scrollRef}
        className="flex gap-2 overflow-x-hidden scrollbar-hide scroll-smooth px-8"
      >
        {allFlowTemplates.map((el) => (
          <button
            key={el.id}
            className={`flex-shrink-0 snap-center px-6 py-2 rounded-full ${
              el.id === activeTemplate?.id
                ? "bg-custom-blue-medium text-white"
                : "bg-white text-[#344054]"
            } font-medium border border-[#EAECF0] ${
              el.type === activeTemplate?.type ? "" : "hover:bg-[#F6F7FB]"
            } transition-colors duration-150`}
            onClick={() => handleClick(el.id)}
          >
            {el.title}
          </button>
        ))}
      </div>

      {/* Right Button */}
      <button
        onClick={() => scrollByAmount(200)}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-1 hover:bg-gray-100"
      >
        <ChevronRightIcon className="w-5 h-5 text-gray-700" />
      </button>
    </div>
  );
}
